import Close from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, InputAdornment, useTheme } from "@mui/material";

import { TextField } from "~/components/design-system/index.js";

export type PatientSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
};

const SEARCH_LABEL = "Search by name or NHS number";

export function PatientSearchField({
  value,
  onChange,
}: PatientSearchFieldProps) {
  const theme = useTheme();

  return (
    <Box sx={{ marginBottom: "1em", maxWidth: "26em" }}>
      <TextField
        name="patientListSearch"
        placeholder={SEARCH_LABEL}
        value={value}
        useFullWidth
        inputProps={{ "aria-label": SEARCH_LABEL }}
        InputProps={{
          startAdornment: (
            <SearchIcon sx={{ mr: 1, color: theme.palette.primary.hint }} />
          ),
          endAdornment:
            value === "" ? undefined : (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Clear search"
                  size="small"
                  edge="end"
                  onClick={() => {
                    onChange("");
                  }}
                >
                  <Close sx={{ color: theme.palette.primary.hint }} />
                </IconButton>
              </InputAdornment>
            ),
        }}
        onChange={onChange}
      />
    </Box>
  );
}
